var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tippy',{staticClass:"is-hidden-mobile",scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{staticClass:"question-icon",domProps:{"innerHTML":_vm._s(require('!html-loader!@/assets/img/question-circle.svg'))}})]},proxy:true}])},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }